export const PROFILE_VERIFICATION_STATUSES = {
  DRAFT: "Draft",
  PENDING: "Pending Verification",
  VERIFIED: "Verified",
  REJECTED: "Rejected",
  CHANGES_REQUESTED: "Changes Requested",
};

export function isPendingVerification(profile) {
  return profile?.profileStatus === PROFILE_VERIFICATION_STATUSES.PENDING;
}

export function isVerifiedProfile(profile) {
  return profile?.profileStatus === PROFILE_VERIFICATION_STATUSES.VERIFIED;
}

export function isRejectedProfile(profile) {
  return profile?.profileStatus === PROFILE_VERIFICATION_STATUSES.REJECTED;
}

export function needsProfileChanges(profile) {
  return profile?.profileStatus === PROFILE_VERIFICATION_STATUSES.CHANGES_REQUESTED;
}
